// api/endpoints/partLaborMapping.js
import { rootApi } from '../rootApi';

export const partLaborMappingApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getParts: builder.query({
      query: ({ languageId, pageNumber = 1, pageSize = 10, partCode }) => ({
        url: 'v1/partlabormapping/get-parts',
        method: 'GET',
        params: {
          LanguageId: languageId,
          PageNumber: pageNumber,
          PageSize: pageSize,
          ...(partCode ? { PartCode: partCode } : {}),
        },
      }),
    }),

    getLabors: builder.query({
      query: ({ languageId }) => ({
        url: 'v1/partlabormapping/get-labors',
        method: 'GET',
        params: { LanguageId: languageId },
      }),
    }),

    addLaborToPart: builder.mutation({
      query: ({ partCode, laborCodes }) => ({
        url: 'v1/partlabormapping/add-labor-to-part',
        method: 'POST',
        body: { partCode, laborCodes },
      }),
    }),

    deleteLaborToPart: builder.mutation({
      query: ({ id }) => ({
        url: 'v1/partlabormapping/delete-labor-to-part',
        method: 'POST',
        body: { id },
      }),
    }),
  }),
});

export const {
  useGetPartsQuery,
  useGetLaborsQuery,
  useAddLaborToPartMutation,
  useDeleteLaborToPartMutation,
} = partLaborMappingApi;
